const isSoldUnit = (unit) => String(unit?.status || '').trim().toLowerCase() === 'sold';

const comparePurchaseUnits = (left, right) => {
  const leftNumber = Number(left?.unit_number);
  const rightNumber = Number(right?.unit_number);
  const safeLeftNumber = Number.isFinite(leftNumber) ? leftNumber : Number.MAX_SAFE_INTEGER;
  const safeRightNumber = Number.isFinite(rightNumber) ? rightNumber : Number.MAX_SAFE_INTEGER;

  if (safeLeftNumber !== safeRightNumber) {
    return safeLeftNumber - safeRightNumber;
  }

  return String(left?.unit_id || left?.unit_code || '').localeCompare(
    String(right?.unit_id || right?.unit_code || ''),
  );
};

export const getUnmatchedSoldUnits = (units = []) => {
  const hasServerClassification = units.some((unit) => typeof unit?.is_unmatched_sold === 'boolean');
  if (hasServerClassification) {
    return units.filter((unit) => unit.is_unmatched_sold === true);
  }

  const unmatched = [];
  const unitsByPurchase = new Map();

  units.forEach((unit) => {
    if (unit?.purchase_id == null) {
      if (isSoldUnit(unit)) {
        unmatched.push(unit);
      }
      return;
    }

    const purchaseKey = String(unit.purchase_id);
    if (!unitsByPurchase.has(purchaseKey)) {
      unitsByPurchase.set(purchaseKey, []);
    }
    unitsByPurchase.get(purchaseKey).push(unit);
  });

  unitsByPurchase.forEach((purchaseUnits) => {
    const rawQuantity = purchaseUnits.find((unit) => unit?.purchase_quantity != null)?.purchase_quantity;
    const parsedQuantity = Number(rawQuantity);
    const purchaseQuantity = Number.isFinite(parsedQuantity)
      ? Math.max(0, Math.floor(parsedQuantity))
      : purchaseUnits.length;

    purchaseUnits
      .slice()
      .sort(comparePurchaseUnits)
      .slice(purchaseQuantity)
      .filter(isSoldUnit)
      .forEach((unit) => unmatched.push(unit));
  });

  return unmatched;
};

export const resolveAvailabilityCount = (availableCount, unmatchedSoldCount) => (
  availableCount > 0
    ? availableCount
    : (unmatchedSoldCount > 0 ? -unmatchedSoldCount : 0)
);

export const applyNegativeAvailability = (availabilityByKey, unmatchedSoldByKey) => {
  unmatchedSoldByKey.forEach((unmatchedCount, key) => {
    const availableCount = availabilityByKey.get(key) || 0;
    if (availableCount === 0 && unmatchedCount > 0) {
      availabilityByKey.set(key, -unmatchedCount);
    }
  });
};
